export default {"src":"/_next/static/media/shareIcon.73e40e00.svg","height":15,"width":19,"blurWidth":0,"blurHeight":0};